var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBox = function SvgBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B9C8F",
    fillRule: "evenodd",
    d: "M2 2.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2ZM2 7h16v8.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Zm5 3.5a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgBox;